import { typographySemanticTokens as s } from "../../tokens/typography.mjs";
const r = {
  serif: s.serif,
  "sans-serif": s["sans-serif"]
};
export {
  r as size
};
